import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'

/**
 * Persistent CTA shown sitewide whenever the signed-in participant has not yet
 * linked their LinkedIn via Publora. Without that link no stats pull, so this
 * needs to feel important without blocking the rest of the dashboard.
 *
 * Hidden on the connect screen itself and on /welcome and /signin to avoid
 * shouting at users who are already in the right place.
 */
export default function ConnectBanner({ participant }) {
  const location = useLocation()

  if (!participant) return null
  if (participant.publora_platform_id) return null

  const hideOn = ['/welcome', '/signin', '/activate/connect']
  if (hideOn.some(p => location.pathname.startsWith(p))) return null

  return (
    <motion.div
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-amber-50 border-b border-amber-200 px-4 py-3"
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="text-2xl shrink-0" aria-hidden>🔗</span>
          <div className="text-sm text-amber-900">
            <strong className="font-semibold">Link LinkedIn to start scoring.</strong>{' '}
            Posts, impression bonuses, and badges only count once Publora is connected.
            Takes 10 seconds, read-only.
          </div>
        </div>
        <Link
          to="/activate/connect"
          className="bg-amber-600 hover:bg-amber-700 text-white font-semibold text-sm px-4 py-2 rounded-lg whitespace-nowrap transition-colors text-center"
        >
          Connect LinkedIn →
        </Link>
      </div>
    </motion.div>
  )
}
